import { FatInvestorsPageListInvestorsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import { TenantType } from '@trace-8/trace8-schema';
import styled from 'styled-components';

interface TableBodyInvestorProps {
  listInvestors: FatInvestorsPageListInvestorsQuery['listInvestors']['data'];
  columns: TableColumns[];
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => Promise<void>;
}

const TableBodyInvestor = ({ listInvestors, columns, openInvestorDetailsPage }: TableBodyInvestorProps) => {
  const { user } = useAuth();

  if (!listInvestors?.length) {
    return <NoResults />;
  }

  return (
    <>
      {listInvestors.map((row) => (
        <CustomTableRowWrapper key={row.id}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openInvestorDetailsPage({ investorId: row.id })}>
              {row.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            {user && user.tenant.type === TenantType.PLATFORM_MANAGER && <TextCell> {row.tenant.name}</TextCell>}
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            <TextCell>{row.investmentCount}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>
              <FormattingTooltip>{row.totalValue}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>
              <FormattingTooltip>{row.totalCommitments}</FormattingTooltip>
            </TextCell>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TableBodyInvestor;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
`;
